import { type CrmRelationsRelationDto as RelatieDto } from './orval-api/model/crmRelationsRelationDto';
import { type CrmRelationsParticuliereRelationDto as ParticuliereRelatieDto } from './orval-api/model/crmRelationsParticuliereRelationDto';
import { type CrmRelationsZakelijkeRelationDto as ZakelijkeRelatieDto } from './orval-api/model/crmRelationsZakelijkeRelationDto';
import { SUREbusinessCommonDomainRelatiesSoortRelatieEnum as SoortRelatie } from './orval-api/model/sUREbusinessCommonDomainRelatiesSoortRelatieEnum';

export function isZakelijkeRelatieDto(relatie: RelatieDto): relatie is ZakelijkeRelatieDto {
  return relatie.typeName === SoortRelatie.Z;
}

export function isParticuliereRelatieDto(relatie: RelatieDto): relatie is ParticuliereRelatieDto {
  return relatie.typeName === SoortRelatie.P;
}

const soortRelatieDisplayTexts = {
  [SoortRelatie.P]: 'Particulier',
  [SoortRelatie.Z]: 'Zakelijk',
};

export const getSoortRelatieDisplayText = (soortRelatie: SoortRelatie) =>
  soortRelatieDisplayTexts[soortRelatie] ?? '';
